// src/components/auth/DriverRedirectComponent.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const DriverRedirectComponent = ({ children }) => {
  const { isDriver, isQrLogin, activeChargerContext } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isDriver()) {
      if (isQrLogin && activeChargerContext) {
        // QR login: redirect to QR route without Layout
        const qrUrl = `/qr/chargers-driver-page?charger_id=${activeChargerContext.charger_id}&company=${activeChargerContext.company_id}&site=${activeChargerContext.site_id}&connector=${activeChargerContext.connector_number}`;
        navigate(qrUrl, { replace: true });
      } else {
        // Normal login: redirect to driver sessions page with Layout
        navigate('/driver-sessions', { replace: true });
      }
    }
  }, [isDriver, isQrLogin, activeChargerContext, navigate]);

  // If user is Driver, don't render children as they will be redirected
  if (isDriver()) {
    return null;
  }

  // For SuperAdmin and Admin, render the children
  return children;
};

export default DriverRedirectComponent;